import { AuditableEntity } from "./audible-entity.model";
import { Customer } from "./customer.model";
import { MeterType } from "./meter-type.model";
import { ContractBaseDeliveryAddress } from "./contract-base-delivery-address";
import { EANCode } from "./ean-code.model";

export class DeliveryAddress extends AuditableEntity {

    constructor(_Id?: number, _CustomerId?: number, _HouseNumber?: string,
        _BusNumber?: string, _IsActive?: boolean, _Note?: string, _Place?: string,
        _PostalCode?: number, _RentedFrom?: Date, _Status?: string, _Street?: string,
        _G_MeterTypeId?: number, _G_YearConsumption?: number, _E_MeterTypeId?: number,
        _E_YearExclNightConsumption?: number, _E_YearLowConsumption?: number,
        _E_YearPeakConsumption?: number, _E_YearSingleConsumption?: number,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string,
        _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date, _CType?: string) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id || 0;
        this.CustomerId = _CustomerId;
        this.HouseNumber = _HouseNumber;
        this.BusNumber = _BusNumber;
        this.IsActive = _IsActive || true;
        this.Note = _Note;
        this.Place = _Place;
        this.PostalCode = _PostalCode;
        this.RentedFrom = _RentedFrom || new Date();
        this.Status = _Status;
        this.Street = _Street;
        this.G_MeterTypeId = _G_MeterTypeId;
        this.G_YearConsumption = _G_YearConsumption;
        this.E_MeterTypeId = _E_MeterTypeId;
        this.E_YearExclNightConsumption = _E_YearExclNightConsumption;
        this.E_YearLowConsumption = _E_YearLowConsumption;
        this.E_YearPeakConsumption = _E_YearPeakConsumption;
        this.E_YearSingleConsumption = _E_YearSingleConsumption;
        this.CType = _CType;
        this.Customer = null;
        this.E_MeterType = null;
        this.G_MeterType = null;

        this.ContractBaseDeliveryAddresses = new Array<ContractBaseDeliveryAddress>();
        this.EanCodes = new Array<EANCode>();
    }

    public Id: number;
    public CustomerId: number;
    public HouseNumber: string;
    public BusNumber: string;
    public IsActive: boolean;
    public Note: string;
    public Place: string;
    public PostalCode: number;
    public RentedFrom: Date;
    public Status: string;
    public Street: string;
    public G_MeterTypeId: number;
    public G_YearConsumption: number;
    public E_MeterTypeId: number;
    public E_YearExclNightConsumption: number;
    public E_YearLowConsumption: number;
    public E_YearPeakConsumption: number;
    public E_YearSingleConsumption: number;
    public CType: string = 'B';
    public Customer: Customer;
    public E_MeterType: MeterType;
    public G_MeterType: MeterType;

    public ContractBaseDeliveryAddresses: ContractBaseDeliveryAddress[];
    public EanCodes: EANCode[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/delivery-address.model.ts